import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { SeguradoraTable } from '../components/seguradora/SeguradoraTable';
import { SeguradoraFormModal } from '../components/seguradora/SeguradoraFormModal';
import type { Seguradora } from '../types/entities';

export const Seguradoras: React.FC = () => {
  const [selectedSeguradora, setSelectedSeguradora] = useState<Seguradora | undefined>();
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateNew = () => {
    setSelectedSeguradora(undefined);
    setModalOpen(true);
  };

  const handleEdit = (seguradora: Seguradora) => {
    setSelectedSeguradora(seguradora);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setSelectedSeguradora(undefined);
    // bump refreshKey to notify table to reload
    setRefreshKey((k) => k + 1);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setSelectedSeguradora(undefined);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-4 gap-2">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-bold" style={{ color: '#3d2b56' }}>
                Gestão de Seguradoras
              </h1>
              <p className="text-xs mt-0.5" style={{ color: '#9E9E9E' }}>
                Gerencie as seguradoras cadastradas no sistema
              </p>
            </div>

            <button
              onClick={handleCreateNew}
              className="px-3 py-1 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-1 focus:ring-offset-1 transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              + Nova Seguradora
            </button>
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
              <SeguradoraTable
                onEdit={handleEdit}
                  refreshKey={refreshKey}
                  onDeleted={() => setRefreshKey((k) => k + 1)}
              />

            {modalOpen && (
              <SeguradoraFormModal
                seguradora={selectedSeguradora}
                onClose={handleCancel}
                onSuccess={handleSuccess}
              />
            )}
          </div>
        </div>

        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>
    </div>
  );
};